import { Box, Card, CardContent } from "@mui/material";

const AuthCard = ({ children }: { children: React.ReactNode }) => (
  <Card sx={{ width: { xs: '100%', sm: 420 }, boxShadow: '0 20px 60px rgba(0,0,0,0.12)', border: 'none' }}>
    <CardContent sx={{ p: { xs: 3, sm: 4 } }}>
      <Box>{children}</Box>
    </CardContent>
  </Card>
);

export default AuthCard;
